import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
    scroll-padding-top: 110px;
  }

  body {
    font-family: 'Inter', 'Poppins', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: ${({ theme }) => theme.colors.background};
    color: ${({ theme }) => theme.colors.textSecondary}; /* Light gray for body text */
    line-height: 1.6;

  }

  .glass {
    background: rgba(255,255,255,0.03); /* subtle tint */
    border: 1px solid rgba(255,255,255,0.06);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border-radius: 12px;
    box-shadow: 0 6px 18px rgba(2,6,23,0.6);
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Poppins', 'Inter', sans-serif; /* Headings with Poppins */
    font-weight: 700;
    color: ${({ theme }) => theme.colors.text}; /* Crisp white for headings */
    line-height: 1.2;
    margin-bottom: 1rem;
  }

  p {
    margin-bottom: 1rem;
  }

  a {
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: ${({ theme }) => theme.colors.secondary};
    }
  }

  :focus-visible { outline: 2px solid var(--focus); outline-offset: 5px; }
  [id] { scroll-margin-top: 110px; }
  button, a { -webkit-tap-highlight-color: transparent; }
  ::selection {
    background: ${({ theme }) => theme.colors.primary};
    color: white;
  }

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.background};
  }

  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.primary};
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.colors.secondary};
  }
`;
